import Icon from 'vue-awesome/components/Icon'

Icon.register({
  timer_two_tone: {
    paths: [
      {
        opacity: '.3',
        d: 'M12.07 6.01c-3.87 0-7 3.13-7 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm1 8h-2v-6h2v6z'
      },
      {
        d: 'M9.07 1.01h6v2h-6zm2 7h2v6h-2z'
      },
      {
        d: 'M19.1 7.39l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012.07 4a9 9 0 00-9 9c0 4.97 4.02 9 9 9A8.994 8.994 0 0019.1 7.39zm-7.03 12.62c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
      }
    ],
    width: '24',
    height: '24'
  }
})
